
    import '/home/ec2-user/Youlify-Design/components/splitter/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["splitter-demo-size","splitter-demo-control","splitter-demo-vertical","splitter-demo-collapsible","splitter-demo-multiple","splitter-demo-group","splitter-demo-nested-in-tabs","splitter-demo-lazy","splitter-demo-debug"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/splitter/index.zh-CN.md?type=demo')
};